/**
 * Registre des pilotes de softphone.
 *
 * Le backend annonce le pilote à charger (`driver` dans GET /api/telephony/token
 * et /status) ; l'interface ne teste jamais le nom du fournisseur.
 *
 * Chaque pilote est chargé **à la demande** : les SDK téléphoniques pèsent
 * plusieurs dizaines de kilo-octets et un poste n'en utilise qu'un. Les embarquer
 * tous ferait payer à chaque utilisateur le prix des fournisseurs qu'il n'a pas.
 * Ajouter un fournisseur = une entrée ici et un fichier à côté, sans alourdir
 * personne.
 */
export const TWILIO_DRIVER = "twilio";
export const TELNYX_DRIVER = "telnyx";

const CHARGEURS = {
  [TWILIO_DRIVER]: () => import("./twilioDriver"),
  [TELNYX_DRIVER]: () => import("./telnyxDriver"),
};

/**
 * Charge le pilote annoncé. Rend `null` si cette version du frontend ne
 * l'embarque pas — le contexte affiche alors « non configuré » plutôt qu'un
 * bouton mort.
 */
export async function loadDriver(name) {
  const chargeur = CHARGEURS[name];
  if (!chargeur) return null;
  try {
    return (await chargeur()).default;
  } catch (e) {
    console.warn(`[telephonie] chargement du pilote « ${name} » impossible`, e);
    return null;
  }
}

export function knownDrivers() {
  return Object.keys(CHARGEURS);
}

export function isKnownDriver(name) {
  return Boolean(CHARGEURS[name]);
}
